import { Component } from "react";

class ProtectedPage extends Component {
  render() {
    return <h3>Protected</h3>;
  }
}

export default ProtectedPage;
